import React from "react";
import { RouteComponentProps } from "react-router-dom";
import CollectionPoints from "./CollectionPoints";
import {
    GetCollectionPointsInput,
    GetCollectionPointsOutput,
    CreateCollectionPointInput,
    CreateCollectionPointOutput,
    UpdateCollectionPointInput,
    UpdateCollectionPointOutput,
    DeleteCollectionPointInput,
    DeleteCollectionPointOutput,
} from "../../client/core";
import { Auth } from "aws-amplify";

export interface CollectionsProps extends RouteComponentProps {
    shopId: string;
    getCollectionPoints: (input: GetCollectionPointsInput) => Promise<GetCollectionPointsOutput | Error>;
    createCollectionPoint: (input: CreateCollectionPointInput) => Promise<CreateCollectionPointOutput | Error>;
    updateCollectionPoint: (input: UpdateCollectionPointInput) => Promise<UpdateCollectionPointOutput | Error>;
    deleteCollectionPoint: (input: DeleteCollectionPointInput) => Promise<DeleteCollectionPointOutput | Error>;
    auth: typeof Auth;
    placesApiKey?: string;
}

const Collections: React.FC<CollectionsProps> = ({
    shopId,
    getCollectionPoints,
    createCollectionPoint,
    updateCollectionPoint,
    deleteCollectionPoint,
    auth,
    placesApiKey,
}) => (
    <CollectionPoints
        shopId={shopId}
        auth={auth}
        getCollectionPoints={getCollectionPoints}
        createCollectionPoint={createCollectionPoint}
        updateCollectionPoint={updateCollectionPoint}
        deleteCollectionPoint={deleteCollectionPoint}
        placesApiKey={placesApiKey}
    />
);

export default Collections;
